import React from "react";
import Logo from "../assets/images/logo.svg";

interface CardProps {
  children: React.ReactNode;
  sx?: React.CSSProperties;
  classNames?: string;
  showCard?: boolean;
  style?: React.CSSProperties;
  title?: string;
  subtitle?: string;
}

export default function Card(props: CardProps) {
  const {
    classNames = "",
    sx,
    children,
    showCard = false,
    style = {},
    title,
    subtitle,
  } = props;
  const combinedStyle: React.CSSProperties = {
    ...sx,
    ...style,
  };

  return (
    <div
      style={combinedStyle}
      className={`rounded-3xl bg-[#F5F5F5] lg:w-[700px] w-full md:mx-0 mx-3 shadow-md ${classNames} ${
        showCard ? "bg-[#F5F5F5]" : ""
      }`}
    >
        <div className="flex justify-center mt-7">
        <img src={Logo} alt="Logo"  />
        </div>
      
      {title && (
        <h2 className="text-[16px] text-[#2B2B2B] lg:text-[48px]  pt-6 font-semibold text-center">
          {title}
        </h2>
      )}

      {subtitle && (
        <span className="text-[12px] block lg:text-[18px] font-normal text-center font:lato">
          {subtitle}
        </span>
      )}

      <div className="p-4 md:px-12 ">{children}</div>
    </div>
  );
}
